// Shared images / content used across pages
export const IMG = {
  hero: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=2400&q=80',
  heroAlt: 'https://images.pexels.com/photos/32726112/pexels-photo-32726112.jpeg?auto=compress&w=2000',
  polish: 'https://images.pexels.com/photos/20042055/pexels-photo-20042055.jpeg?auto=compress&w=1600',
  taillight: 'https://images.unsplash.com/photo-1474065581914-e24d783b0c55?auto=format&fit=crop&w=1400&q=80',
  headlight: 'https://images.unsplash.com/photo-1666887512264-df0a92a2187c?auto=format&fit=crop&w=1400&q=80',
  interior: 'https://images.unsplash.com/photo-1618866157430-b4d2e6a8800b?auto=format&fit=crop&w=1600&q=80',
  carWash: 'https://images.pexels.com/photos/3354648/pexels-photo-3354648.jpeg?auto=compress&w=1600',
  luxury1: 'https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1600&q=80',
  luxury2: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=1600&q=80',
  truck: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=1600&q=80',
  suv: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=1600&q=80',
  engine: 'https://images.unsplash.com/photo-1486496146582-9ffcd0b2b2b7?auto=format&fit=crop&w=1600&q=80',
  wheel: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/c5dpr5mj_Wheels%20and%20tires.JPG',
  beforeWash: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/pva10p41_before%20car.png',
  afterWash: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/723vxg6i_after%20car.png',
  boatBefore: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/r4s8gy5c_boat%20before.JPG',
  boatAfter: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/bx4g07ph_boat%20after.JPG',
  premiumInterior: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/yov6gtmh_Premium%20interior%20detail%20.JPG',
  premiumExterior: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/68g7v8dt_premium%20detail%20exterior.JPG',
  truckDetail: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/r0184huc_Truck%20Detail.JPG',
  lexusExterior: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/0mye2t0l_Lexus%20exterior%20detail.JPG',
  lexusInterior: 'https://customer-assets.emergentagent.com/job_polish-mobile-4/artifacts/n4gat8fo_Lexus%20Premium%20Interior.JPG',
  fleet: 'https://images.pexels.com/photos/2199293/pexels-photo-2199293.jpeg?auto=compress&w=1600',
  regularDetail: 'https://images.pexels.com/photos/3354648/pexels-photo-3354648.jpeg?auto=compress&w=1600',
};

export const FEATURES = [
  { icon: 'MapPin', title: 'We Come To You', desc: 'We come right to your house — no shop visits, ever.' },
  { icon: 'Sparkles', title: 'Premium Products', desc: 'Pro-grade chemicals, polishes, and ceramic-safe formulas.' },
  { icon: 'Wrench', title: 'Professional Equipment', desc: 'Hot extraction + steam. Pro-grade tools for every detail.' },
  { icon: 'ScanEye', title: 'Attention To Detail', desc: 'Every panel, vent, and stitch is treated with care.' },
  { icon: 'BadgeDollarSign', title: 'Honest Pricing', desc: 'No upsells. No surprises. Clear flat rates.' },
  { icon: 'Heart', title: 'Customer Satisfaction', desc: 'We don\'t leave until your car feels showroom-new.' },
];

export const HOW_IT_WORKS = [
  { step: '01', title: 'Book Online', desc: 'Pick a package, date, and time in under 60 seconds.' },
  { step: '02', title: 'We Arrive', desc: 'Fully equipped truck shows up on schedule, every time.' },
  { step: '03', title: 'We Detail Your Vehicle', desc: 'Showroom-grade interior + exterior care, panel by panel.' },
  { step: '04', title: 'Enjoy The Results', desc: 'Step into a vehicle that looks and feels brand-new.' },
];

export const TESTIMONIALS = [
  { name: 'Marcus T.', role: 'Porsche 911 Owner', rating: 5, text: 'They treated my 911 like a museum piece. The interior looks better than the day I bought it.' },
  { name: 'Jasmine R.', role: 'BMW M4 Owner', rating: 5, text: 'Absolutely worth every dollar. They worked around my schedule and the finish is mirror-perfect.' },
  { name: 'David K.', role: 'Tesla Model S Owner', rating: 5, text: 'Showed up on time, explained everything, and left my Tesla immaculate. Will be a repeat customer.' },
  { name: 'Sarah L.', role: 'Range Rover Owner', rating: 5, text: 'Professional, polite, and meticulous. The carpet shampoo result was unbelievable.' },
  { name: 'Anthony P.', role: 'Ford F-150 Owner', rating: 5, text: 'Best detail I\'ve had in 10 years of owning trucks. Hauled mulch all summer — looks brand new now.' },
];

export const FAQS = [
  { q: 'Do you come to my house?', a: 'Yes. We are 100% mobile and travel throughout Lincoln, NE and surrounding areas. We bring our fully equipped truck right to your house.' },
  { q: 'Do I need to provide water?', a: 'Yes. We ask that customers provide access to a standard outdoor water hookup (spigot) so we can wash and rinse your vehicle.' },
  { q: 'Do I need electricity?', a: 'Yes. We need access to a standard household outlet to power our vacuums, extractors, and steam equipment.' },
  { q: 'How long does detailing take?', a: 'A Regular Detail takes about 1.5–2 hours. A Premium Detail typically takes 3–5 hours depending on vehicle size and condition.' },
  { q: 'What payment methods do you accept?', a: 'Cash, Apple Pay, Venmo, and Zelle.' },
  { q: 'What vehicles do you service?', a: 'Sedans, coupes, sports cars, SUVs, trucks, luxury / exotic vehicles, semi trucks, and boats. Every vehicle gets the same premium care.' },
  { q: 'Can you detail luxury vehicles?', a: 'Absolutely — luxury and high-end vehicles are our specialty. We use ceramic-safe products and soft, scratch-free methods.' },
  { q: 'Do you offer fleet detailing?', a: 'Yes. We service business fleets — multiple company cars, work trucks, or service vehicles. Fleet jobs are custom-quoted; text or call us at (531) 350-2541 for a fleet quote.' },
  { q: 'How do I schedule?', a: 'Use the Book Your Detail button on this site, or call us directly. You\'ll get a confirmation within hours.' },
  { q: 'Do you work year-round?', a: 'Yes. We operate year-round in Lincoln, weather permitting. Some heavy snow days may be rescheduled for safety.' },
];

export const ADDONS = [
  { id: 'engine_bay', label: 'Engine Bay Cleaning', price: '$50', priceNum: 50 },
  { id: 'pet_hair', label: 'Pet Hair Removal', price: 'Starting at $45', priceNum: 45 },
  { id: 'heavy_stain', label: 'Heavy Stain Removal', price: 'Starting at $40', priceNum: 40 },
  { id: 'protector_wax', label: 'Paint Protection Wax', price: '$30', priceNum: 30 },
  { id: 'clay_bar', label: 'Clay Bar Treatment', price: 'Starting at $60', priceNum: 60 },
  { id: 'trash_removal', label: 'Excessive Trash Removal', price: 'Starting at $25', priceNum: 25 },
  { id: 'odor_elimination', label: 'Odor Elimination', price: 'Starting at $50', priceNum: 50 },
  { id: 'water_spot', label: 'Water Spot Removal', price: 'Starting at $40', priceNum: 40 },
];

export const VEHICLE_TYPES = [
  { id: 'sedan', label: 'Sedan' },
  { id: 'coupe', label: 'Coupe' },
  { id: 'truck', label: 'Truck' },
  { id: 'suv', label: 'SUV' },
  { id: 'suv3row', label: '3-Row SUV / Minivan' },
];

export const PREMIUM_KEYS = new Set(['premium', 'interior_premium', 'exterior_premium']);
export const PROMO_LABEL = '20% OFF';
export const PROMO_RATE = 0.8;

/** Returns { original, discounted, promo } for a given package + vehicle type. */
export function packagePrice(pkgKey, vehType) {
  const original = PACKAGES?.[pkgKey]?.prices?.[vehType] ?? 0;
  if (PREMIUM_KEYS.has(pkgKey)) {
    return { original, discounted: Math.round(original * PROMO_RATE), promo: true };
  }
  return { original, discounted: original, promo: false };
}

export const PACKAGES = {
  regular: {
    name: 'Regular Detail',
    category: 'Full Detail',
    tagline: 'Showroom-fresh basics',
    prices: { sedan: 144, coupe: 144, truck: 180, suv: 180, suv3row: 210 },
    includes: [
      'Exterior hand wash',
      'Wheel and tire cleaning',
      'Interior vacuum',
      'Dash, doors and center console wipe down',
      'Interior and exterior windows',
      'Tire shine',
    ],
  },
  premium: {
    name: 'Premium Detail',
    category: 'Full Detail',
    tagline: 'The flagship treatment',
    prices: { sedan: 240, coupe: 240, truck: 258, suv: 258, suv3row: 288 },
    includes: [
      'Everything in Regular Detail',
      'Deep interior cleaning',
      'Full carpet shampoo',
      'Seat shampoo',
      'Steam cleaning',
      'Leather cleaning and conditioning (when applicable)',
      'Interior protectant',
      'Bug and tar removal',
    ],
  },
  interior_regular: {
    name: 'Interior Regular',
    category: 'Interior Only',
    tagline: 'Fresh inside, top to bottom',
    prices: { sedan: 120, coupe: 120, truck: 145, suv: 145, suv3row: 175 },
    includes: [
      'Vacuum',
      'Dash, doors and console wipe down',
      'Interior windows',
      'Floor mats cleaned',
      'Door jambs wiped down',
      'Light dust removal',
    ],
  },
  interior_premium: {
    name: 'Interior Premium',
    category: 'Interior Only',
    tagline: 'Deep clean, every crevice',
    prices: { sedan: 180, coupe: 180, truck: 210, suv: 210, suv3row: 240 },
    includes: [
      'Everything in Interior Regular',
      'Deep interior cleaning',
      'Carpet and seat shampoo',
      'Steam cleaning',
      'Leather conditioning (when applicable)',
      'Interior protectant',
      'Deep cleaning of hard-to-reach areas',
    ],
  },
  exterior_regular: {
    name: 'Exterior Regular',
    category: 'Exterior Only',
    tagline: 'Clean paint, sharp finish',
    prices: { sedan: 70, coupe: 70, truck: 90, suv: 90, suv3row: 110 },
    includes: [
      'Hand wash',
      'Wheel and tire cleaning',
      'Exterior windows',
      'Tire shine',
      'Quick spray wax',
    ],
  },
  exterior_premium: {
    name: 'Exterior Premium',
    category: 'Exterior Only',
    tagline: 'Show-quality shine',
    prices: { sedan: 130, coupe: 130, truck: 150, suv: 150, suv3row: 175 },
    includes: [
      'Everything in Exterior Regular',
      'Bug removal',
      'Clay bar treatment (if needed)',
      'Protector wax',
      'Wheel wells cleaned',
      'Trim dressing',
      'Spot-free drying',
    ],
  },
};

export const CONTACT = {
  phone: '(531) 350-2541',
  phoneRaw: '5313502541',
  fleetPhone: '(531) 350-2541',
  fleetPhoneRaw: '5313502541',
  email: 'expressdetailing402@gmail.com',
  address: 'Lincoln, Nebraska',
  experience: '3+ Years Of Professional Detailing',
  instagram: 'https://www.instagram.com/expressdetailz/',
  facebook: 'https://www.facebook.com/people/Express-Details/61590362600161/',
  googleReviewUrl: 'https://share.google/WA9HbETBjq7CbgFSP',
  googleSearchUrl: 'https://www.google.com/search?q=Express+Detailz+Lincoln+NE',
  hours: [
    { day: 'Mon – Fri', time: '8:00 AM – 7:00 PM' },
    { day: 'Saturday', time: '8:00 AM – 6:00 PM' },
    { day: 'Sunday', time: '10:00 AM – 4:00 PM' },
  ],
};

export const TIME_SLOTS = ['9:00 AM','11:30 AM','2:00 PM','5:00 PM'];
